import { createQueryStringToggleHook } from "../../../../../stores/useQueryState";

export const useTirePLYRatingParamName = "ply";

export const useTirePLYRating = createQueryStringToggleHook(
  useTirePLYRatingParamName,
  []
);
